var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDisasterRecovery = function SvgDisasterRecovery(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_994_20555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64.01C3.77.197.64 3.47.62 7.347c-.015 3.27 2.105 6.045 5.045 7.025l-1.64.725c-.05.02-.07.08-.05.13l.315.715c.02.05.08.07.13.05l3.125-1.38c.05-.02.07-.08.05-.13l-.165-.38-1.215-2.745c-.02-.05-.08-.07-.13-.05l-.715.315c-.05.02-.07.08-.05.13l.67 1.68c-2.635-.875-4.515-3.415-4.37-6.375C1.78 3.806 4.48 1.13 7.735 1a6.4 6.4 0 0 1 6.65 6.385c0 2.775-1.78 5.135-4.255 6.015a.2.2 0 0 0-.13.185v.775c0 .06.06.105.115.085 3.04-.91 5.265-3.73 5.265-7.065 0-4.19-3.505-7.575-7.74-7.37",
    fill: "#130C0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.13 10.35 7.545 7.79a.1.1 0 0 1-.04-.08V3.6a.093.093 0 0 1 .095-.1h.8a.1.1 0 0 1 .1.1v3.515c0 .08.04.155.105.2l3.105 2.22c.045.03.055.095.025.14l-.465.65a.103.103 0 0 1-.14.025",
    fill: "#140F10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_994_20555"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgDisasterRecovery;